import { ConsentAcceptance } from './consent-acceptance';

export class CustomerConsent {
    public acceptances: ConsentAcceptance[];
}